import { render } from "./VistaAprobacion.vue?vue&type=template&id=dfaf10f6"
import script from "./VistaAprobacion.vue?vue&type=script&lang=js"
export * from "./VistaAprobacion.vue?vue&type=script&lang=js"

import "./VistaAprobacion.vue?vue&type=style&index=0&id=dfaf10f6&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__